import Styles from './Urgency.module.scss';

export interface UrgencyProps {
    Name: string | null;
    Abbreviation: string | null;
    Color: string | null;
}

export function Urgency(props: Readonly<UrgencyProps>): React.ReactElement {
    const abbreviation = props.Abbreviation ?? '';
    const name = props.Name ?? '';
    const titleParts = [name, abbreviation].filter((part) => part.trim() !== '');
    const title = titleParts.join(' - ');
    const color = props.Color ?? '';
    return (
        <div className={Styles.urgency} style={{ backgroundColor: color }} title={title}>
            { abbreviation }
        </div>
    );
}
